import { v4 as uuid } from 'uuid';
import SectionsPostMultiple from './SectionPostMultiple';
import {
  MetaDataElement,
  MetaDataOptions,
} from '../../../app/models/metaDataConfig';
import { store } from '../../../app/stores/store';
import { WorkflowOptions, WorkflowElement } from '../../../app/models/template';
import agent from '../../../app/api/agent';
import { Activity } from '../../../app/models/activity';
import { metadataType } from '../../../app/api/types';

export async function ReadFromCSV(
  importedData: any,
  uploadFileDetails2: any,
  activity: any,
  selectedTemplate: any,
  selectedAssetTypeId: string,
  elementID: string,
  assetTypeName: string,
  elementTypeName: string,
  selectedWorkLevelItemsForName: Activity[] | [],
  metadata: metadataType[],
  nfaiParentId: any,
) {
  const IsNfaiReport = store?.userStore?.user?.customerName === 'NFAIReport';
  // const exportData=[];
  if (importedData !== undefined) {
    const FilmArray: string[] = [];
    selectedWorkLevelItemsForName.forEach((x: { title: string }) =>
      FilmArray.push(x.title),
    );
    //imported data contanins multiple array of strings
    //importeddata[0] contains headers, rest index contains value
    let currentReel = 0;
    let PreviousReel = 0;
    let tildeValue = 1;
    for (let i = 1; i < importedData.length - 1; i++) {
      //loop the imported data
      const headerKeys = importedData[0]; //header always 0 index
      const values = importedData[i]; //value index starts from 1 ;

      // let IncFilmName = FimTitle.includes("~") ? FimTitle : FimTitle + "~1";

      if (headerKeys?.length) {
        //only when rows contains even a single value

        let mainObj: any = {}; //create the empty output object
        //creating the array of obj,this obj contains duplicate value
        const duplicateArrofObj = headerKeys?.map(
          (str: any, index: number) => ({ [str]: values[index] }),
        );

        let metadatas: any = [];
        if (uploadFileDetails2 !== undefined) {
          metadatas = [...uploadFileDetails2];
        }
        //creating the array of obj,this obj contains duplicate value
        mainObj.id = uuid();
        mainObj.element = elementTypeName;
        mainObj.type = assetTypeName;
        mainObj.elementtypeid = elementID;
        mainObj.typeid = selectedAssetTypeId;

        let workflows: any = [];
        if (selectedTemplate) {
          let localSelectedTemplate = { ...selectedTemplate };
          localSelectedTemplate.templateId = uuid();

          for (let i = 0; i < localSelectedTemplate?.tasks?.length; i++) {
            localSelectedTemplate.tasks[i].taskId = uuid();
            for (
              let j = 0;
              j < localSelectedTemplate?.tasks?.[i]?.subTasks;
              j++
            ) {
              localSelectedTemplate.tasks[i].subTasks.subTaskId = uuid();
              for (
                let k = 0;
                k < localSelectedTemplate?.tasks?.[i]?.subTasks?.[j]?.elements;
                k++
              ) {
                localSelectedTemplate.tasks[i].subTasks[j].elements[
                  k
                ].elementId = uuid();
                for (
                  let L = 0;
                  L <
                  localSelectedTemplate?.tasks?.[i]?.subTasks?.[j]?.elements?.[
                    k
                  ]?.options;
                  L++
                ) {
                  localSelectedTemplate.tasks[i].subTasks[j].elements[
                    k
                  ].options[L].optionId = uuid();
                }
              }
            }
            localSelectedTemplate.tasks[i].subTasks.map((subTask: any) => {
                subTask.elements?.map((element: any) => {
                  const isDropdown = element.elementType  === 'DropDown'
                  element.elementValue = isDropdown ? element.options.filter((e:any) => e.isSelected === true)?.[0]?.optionName || '' : element.elementValue; // Modify the element value
                  return element;
                });
                return subTask;
              })  
          }
          if (localSelectedTemplate) {
            workflows = [
              {
                orderId: uuid(),
                orderDateTime: new Date().toISOString(),
                username: store.userStore.user?.displayName,
                customerId: store.userStore.user?.customerName,
                departmentId: '',
                templateId: localSelectedTemplate.templateId,
                isActive: true,
                isReceiving: true,
                isDelivery: false,
                isReturn: false,
                itemOrderReceiving: [
                  {
                    id: uuid(),
                    customerId: store.userStore.user?.customerName,
                    departmentId: '',
                    receivingId: '', //put receiving id later
                    isActive: true,
                    receivingWorkflows: [localSelectedTemplate],
                  },
                ],
              },
            ];
          }
        }
        mainObj.orders = workflows;

        mainObj.metadata = metadatas;
        // eslint-disable-next-line
        duplicateArrofObj.forEach(function (item: any) {
          const key = Object.keys(item)[0]; //take the first key from every object in the array

          if (key.includes('.')) {
            let keylength = key.split('.').length;
            if (
              keylength === 4 &&
              mainObj?.orders[0]?.itemOrderReceiving[0]?.receivingWorkflows[0]
            ) {
              const taskindex =
                mainObj.orders[0].itemOrderReceiving[0].receivingWorkflows[0].tasks.findIndex(
                  (x: any) => x.taskName === key.split('.')[1],
                );
              if (taskindex !== undefined && taskindex !== -1) {
                const subtaskindex =
                  mainObj.orders[0].itemOrderReceiving[0].receivingWorkflows[0].tasks[
                    taskindex
                  ].subTasks.findIndex(
                    (y: any) => y.subTaskName === key.split('.')[2],
                  );
                if (subtaskindex !== undefined && subtaskindex !== -1) {
                  const elementIndex =
                    mainObj.orders[0].itemOrderReceiving[0].receivingWorkflows[0].tasks[
                      taskindex
                    ].subTasks[subtaskindex].elements.findIndex(
                      (y: any) => y.elementName === key.split('.')[3],
                    );

                  if (elementIndex !== undefined && elementIndex !== -1) {
                    const elemType: WorkflowElement =
                      mainObj.orders[0].itemOrderReceiving[0]
                        .receivingWorkflows[0].tasks[taskindex].subTasks[
                        subtaskindex
                      ].elements[elementIndex];
                    if (elemType.elementType === 'DropDown') {
                      let result = elemType?.options.filter(
                        (obj: WorkflowOptions) => {
                          return obj.optionName === item[key];
                        },
                      );
                      if (result.length === 0) {
                        let newArr = {
                          isSelected: true,
                          optionId: uuid(),
                          optionName: item[key],
                          optionLinkId: '',
                          optionLinkName: '',
                          optionIndex: elemType.options.length + 1,
                          optionDateTime: new Date().toISOString(),
                          isActive: true,
                          isDeleted: false,
                        };
                        elemType.options.push(newArr);
                        //if Dropdown add a new Option in case no option present
                        mainObj.orders[0].itemOrderReceiving[0].receivingWorkflows[0].tasks[
                          taskindex
                        ].subTasks[subtaskindex].elements[elementIndex] = {
                          ...elemType,
                          elementValue: item[key],
                        };
                      } else {
                        mainObj.orders[0].itemOrderReceiving[0].receivingWorkflows[0].tasks[
                          taskindex
                        ].subTasks[subtaskindex].elements[
                          elementIndex
                        ].elementValue = item[key];
                      }
                    } else {
                      mainObj.orders[0].itemOrderReceiving[0].receivingWorkflows[0].tasks[
                        taskindex
                      ].subTasks[subtaskindex].elements[
                        elementIndex
                      ].elementValue = item[key];
                    }
                  }
                }
              }
            }
          } else if (key.includes('Metadata')) {
            const metadataindex = mainObj?.metadata?.findIndex((x: any) => {
              return x.elementName === key.split('~')[1];
            });

            if (metadataindex !== undefined && metadataindex !== -1) {
              const metadatatype: MetaDataElement =
                mainObj.metadata[metadataindex];
              if (metadatatype.elementType === 'DropDown') {
                let result = metadatatype?.options?.filter(
                  (obj: MetaDataOptions) => {
                    return obj.optionName === item[key];
                  },
                );
                if (result?.length === 0) {
                  let newArr = {
                    isSelected: true,
                    optionId: uuid(),
                    optionName: item[key],
                    optionLinkId: '',
                    optionLinkName: '',
                    optionIndex: metadatatype.options.length + 1,
                    optionDateTime: new Date().toISOString(),
                    isActive: true,
                    isDeleted: false,
                  };
                  metadatatype.options.push(newArr);
                  mainObj.metadata[metadataindex] = metadatatype;
                } else {
                  mainObj.metadata[metadataindex].elementValue = item[key];
                }
              }
              mainObj.metadata[metadataindex].elementValue = item[key];
            }
          } else {
            mainObj[key] = item[key]; //assign the key and value to output obj
          }

          if (
            IsNfaiReport &&
            mainObj.type === 'Reel' &&
            mainObj.element === 'Cutlist' &&
            key === 'Metadata~Reel No'
          ) {
            // let title = activity.parent.split('/')[1]?.split('-');
            const parentDetails = nfaiParentId.filter((element: any) => {
              const reelNo = element.reelNo;
              const itemReel = item['Metadata~Reel No']?.replace(/^0+/, '');
            
              if (!reelNo || !itemReel) return false;
            
              // If reelNo contains '_' or '+'
              if (reelNo.includes('_') || reelNo.includes('+')) {
                const [part1, part2] = reelNo.split(/[_+]/);
                const [itemPart1, itemPart2] = itemReel.split('+');
            
                return part1 === itemPart1 || part2 === itemPart2;
              }
            
              // Simple equality
              return reelNo === itemReel;
            });
            
            
            const parent = parentDetails[0];
            // eslint-disable-next-line
            currentReel = parent?.reelNo;
            if (currentReel !== PreviousReel) {
              tildeValue = 1;
            }
            let parentTitle = activity.parent.split('/')[1] || '';
            let dashIndex = parentTitle.indexOf('-');

            let titlePrefix = parentTitle.substring(0, dashIndex).trim();
            let titleRest = parentTitle.substring(dashIndex + 1).trim();
            mainObj[`title`] =
              titlePrefix +
              '-' +
              titleRest +
              '-' +
              ` Reel ${parent?.reelNo || ''} ` +
              '-' +
              ' Cutlist ' +
              `~${tildeValue}`;
            mainObj[`parent`] = parent?.parentId + '/' + parent?.parentName;
            // eslint-disable-next-line
            PreviousReel = currentReel;
            // eslint-disable-next-line
            tildeValue++;
          }

          if (
            IsNfaiReport &&
            mainObj.type === 'Reel' &&
            mainObj.element === 'Cutlist' &&
            key === 'Metadata~Emp ID'
          ) {
            mainObj[`displayname`] = item[`Metadata~Emp ID`];
          }
        });
        await SectionsPostMultiple(
          mainObj,
          activity,
          i,
          importedData.length,
          metadata,
          nfaiParentId,
        );

        if (i === 1) {
          agent.Reports.metadataHeadersPostItemID(mainObj.id); //To Update MetaData Header Table
        }
      }
    }
  }
}
